var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("BasicInputs", {
        attrs: { loading: _vm.loading, "form-data": _vm.formData },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { attrs: { disabled: _vm.loading } },
        [
          _c(
            "NumberOfGuests",
            {
              attrs: {
                loading: _vm.loading,
                "form-data": _vm.formData,
                "max-available-places": _vm.maxAvailablePlaces,
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("booking.inputs.numberOfGuests.labelEnquiry")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "requested_single_rooms" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t("booking.inputs.requested_single_rooms.label")
                  ) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.requested_single_rooms,
                  expression: "formData.requested_single_rooms",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                name: "requested_single_rooms",
                id: "requested_single_rooms",
                min: _vm.minFreePlaces,
                max: _vm.formData.number_of_guests,
                required: "",
              },
              domProps: { value: _vm.formData.requested_single_rooms },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.formData,
                    "requested_single_rooms",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("fieldset", { attrs: { disabled: _vm.loading } }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("label", { attrs: { for: "note" } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("booking.inputs.question.label")) +
                ":\n            "
            ),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.note,
                expression: "formData.note",
              },
            ],
            staticClass: "form-control",
            attrs: {
              name: "note",
              id: "note",
              maxlength: "2000",
              placeholder: _vm.$t("booking.inputs.question.placeholder"),
              rows: "4",
            },
            domProps: { value: _vm.formData.note },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "note", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.mailchimp
        ? _c("MailchimpSubscription", {
            attrs: { loading: _vm.loading, "form-data": _vm.formData },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3 pb-0 mt-3 text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-block btn-primary",
            attrs: { type: "submit", disabled: _vm.loading },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("booking.enquiry")) +
                "\n        "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }